import { Temporal } from "@js-temporal/polyfill";
import Land from "./land/Land";
import { NumberBoard } from "./number/Number";
import { RandomWorld } from "./random-world/randomWorld.jsx";
import { ScavengerHunt } from "./scavenger-hunt/ScavengerHunt";
import { StickOrRock } from "./stickorrock/StickOrRock.js";

export const GAME_KEYS = {
  HUNT: { key: 'HUNT', route: '/hunt', component: <ScavengerHunt />, name: 'Hunt' },
  NUMBERS: { key: 'NUMBERS', route: '/numbers', component: <NumberBoard />, name: "Numbers" },
  LAND: { key: 'LAND', route: '/land', component: <Land />, name: "Land, Ho" },
  RANDOM_WORLD: { key: 'RANDOM_WORLD', route: '/hello-woods', component: <RandomWorld />, name: "Hello Woods" },
  STICK_OR_ROCK: { key: 'STICK_OR_ROCK', route: '/stick-or-rock', component: <StickOrRock />, name: "Stick or Rock" }
};

export const TIME_ZONE = 'America/New_York';
export const TIME_ZONE_TEMPORAL = Temporal.TimeZone.from(TIME_ZONE);

const REACT_APP_ENABLED_GAMES = process.env?.REACT_APP_ENABLED_GAMES ?? [];
export const ENABLED_GAMES = Object.values(GAME_KEYS).filter(({ key }) => REACT_APP_ENABLED_GAMES.includes(key));

export const DEV_MODE = process.env?.REACT_APP_ENABLED_DEV_MODE ?? false;